import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import { ProductCardPropType } from "web/types/product-card";
import LeadLink from "web/react/components/lead-link/lead-link";
import styles from "./product-gallery-more-products.css";

function Product({ product }) {
    const content = (
        <div>
            <img className={styles.product} src={product.image_url} />
        </div>
    );

    return (
        <div className={styles.card}>
            {product.lead_enabled ? (
                <LeadLink
                    reason="image-gallery-related"
                    href={product.lead_url}
                    openInNewTab={true}
                >
                    {content}
                </LeadLink>
            ) : (
                <a href={product.url}>{content}</a>
            )}
        </div>
    );
}

Product.propTypes = {
    product: ProductCardPropType.isRequired,
};

function MoreProducts({ products, fullscreen }) {
    const renderedProducts = products.map((product) => {
        return <Product key={product.image_url} product={product} />;
    });

    const wrapperClasses = classnames(styles.wrapper, {
        [styles.fullscreen]: fullscreen,
    });

    return (
        <div className={wrapperClasses}>
            <div className={styles.container}>
                <h3 className={styles.title}>
                    {gettext("product.product_more_details_try_instead")}
                </h3>
                <div className={styles.products}>{renderedProducts}</div>
            </div>
        </div>
    );
}

export default MoreProducts;

MoreProducts.propTypes = {
    products: PropTypes.array.isRequired,
    fullscreen: PropTypes.bool,
};

MoreProducts.defaultProps = {
    fullscreen: false,
};
